import styled from '@emotion/styled/macro';

export const Main = styled.main`
  border: 1px solid rgba(207, 207, 207, 0.64);
  min-height: 220px;
  font-size: 14px;
  max-width: 1000px;
  box-shadow: 1px 1px 2px -1px rgba(207, 207, 207, 0.64);
  box-sizing: border-box;
`;

export const Buttons = styled.div`
  display: flex;
  gap: 10px;
  padding: 7px;
  button {
    border: none;
    background-color: transparent;
    cursor: pointer;
    transition:
      transform 0.3s,
      box-shadow 0.3s;
  }

  button:hover {
    transform: translateY(-1.5px);
  }
`;

export const InsertText = styled.div`
  border-top: 1px solid rgba(207, 207, 207, 0.86);
  direction: ltr;
  text-align: left;
  max-height: 80%;
  max-width: 100%;
  font-size: 13px;
  padding: 15px;
  min-width: 400px;
  box-sizing: border-box;
`;
